import { render, staticRenderFns } from "./GeneratedContentBorders.vue?vue&type=template&id=35059d7d&"
import script from "./GeneratedContentBorders.vue?vue&type=script&lang=js&"
export * from "./GeneratedContentBorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports